var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.Language-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Language-st0",
    d: "M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8c4.4,0,8-3.6,8-8S12.4,0,8,0z M13.5,4.8h-2.4c-0.3-1-0.6-2-1.1-2.8 C11.5,2.5,12.8,3.5,13.5,4.8z M8,1.6c0.7,1,1.2,2,1.5,3.2H6.5C6.8,3.7,7.3,2.6,8,1.6z M1.8,9.6C1.7,9.1,1.6,8.6,1.6,8 s0.1-1.1,0.2-1.6h2.7C4.4,6.9,4.4,7.5,4.4,8s0,1.1,0.1,1.6H1.8z M2.5,11.2h2.4c0.3,1,0.6,2,1.1,2.8C4.5,13.5,3.2,12.5,2.5,11.2z  M4.8,4.8H2.5c0.8-1.3,2-2.3,3.5-2.8C5.4,2.8,5.1,3.8,4.8,4.8z M8,14.4c-0.7-1-1.2-2-1.5-3.2h3.1C9.2,12.3,8.7,13.4,8,14.4z  M9.9,9.6H6.1C6.1,9.1,6,8.5,6,8s0.1-1.1,0.1-1.6h3.7C9.9,6.9,10,7.5,10,8S9.9,9.1,9.9,9.6z M10.1,14c0.5-0.9,0.8-1.8,1.1-2.8h2.4 C12.8,12.5,11.5,13.5,10.1,14z M11.5,9.6c0.1-0.5,0.1-1.1,0.1-1.6s0-1.1-0.1-1.6h2.7c0.1,0.5,0.2,1,0.2,1.6s-0.1,1.1-0.2,1.6H11.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.b4e8ef5b2d209309d6581d7629e44bb6.svg";
export { ForwardRef as ReactComponent };